export const ZONE_DECAL_PRICE = 10;
